export { default as Certificates } from './Certificates';
export { default as CertificatesAddCalendarEvent } from './CertificatesAddCalendarEvent';
export { default as CertificatesAddCourse } from './CertificatesAddCourse';
export { default as CertificatesAddPath } from './CertificatesAddPath';
export { default as CertificatesProductItem } from './CertificatesProductItem';
export { default as CertificatesCreate } from './CertificatesCreate';
export { default as CertificatesDelete } from './CertificatesDelete';
export { default as CertificatesEdit } from './CertificatesEdit';
export { default as CertificatesFiles } from './CertificatesFiles';
export { default as CertificatesImport } from './CertificatesImport';
export { default as CertificatesList } from './CertificatesList';
export { default as CertificatesPreview } from './CertificatesPreview';
export { default as CertificatesSelectTemplate } from './CertificatesSelectTemplate';
export { default as CertificatesSetDefault } from './CertificatesSetDefault';
export { default as CertificatesSettings } from './CertificatesSettings';
